module.exports = __webpack_public_path__ + "img/portfolio.53c70dd1.png";